import { useState, useEffect, useCallback } from "react";

function parseHash() {
  const parts = window.location.hash.replace("#", "").split("/").filter(Boolean);
  return { main: parts[0] || "", sub: parts[1] || null, sub2: parts[2] || null };
}

function setHash(main, sub, sub2) {
  const parts = [main, sub, sub2].filter(Boolean);
  window.location.hash = parts.join("/");
}

export function useHashTabs(defaultMain) {
  const [main, setMainState] = useState(() => parseHash().main || defaultMain);
  const [sub, setSubState] = useState(() => parseHash().sub);
  const [sub2, setSub2State] = useState(() => parseHash().sub2);

  const setMain = useCallback((m) => {
    setMainState(m);
    const current = parseHash();
    if (current.main === m && current.sub) return;
    setSubState(null);
    setSub2State(null);
    setHash(m);
  }, []);

  const setSub = useCallback((s) => {
    setSubState(s);
    const current = parseHash();
    if (current.sub === s) return;
    setSub2State(null);
    setHash(current.main || main, s);
  }, [main]);

  const setSub2 = useCallback((s) => {
    setSub2State(s);
    const current = parseHash();
    if (current.sub2 === s) return;
    setHash(current.main || main, current.sub || sub, s);
  }, [main, sub]);

  useEffect(() => {
    const onHash = () => {
      const p = parseHash();
      if (p.main && p.main !== main) { setMainState(p.main); setSubState(p.sub); setSub2State(p.sub2); }
      else if (p.main && p.sub !== sub) { setSubState(p.sub); setSub2State(p.sub2); }
      else if (p.main && p.sub && p.sub2 !== sub2) { setSub2State(p.sub2); }
    };
    window.addEventListener("hashchange", onHash);
    return () => window.removeEventListener("hashchange", onHash);
  }, [main, sub, sub2]);

  return [main, setMain, sub, setSub, sub2, setSub2];
}
